var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4594 6.01238C21.6898 6.35373 20.8626 6.58442 19.9946 6.68815C20.8805 6.15701 21.5611 5.31598 21.8815 4.31378C21.0522 4.80564 20.1338 5.16278 19.1562 5.3552C18.3734 4.52112 17.2581 4 16.0237 4C13.6536 4 11.7319 5.92147 11.7319 8.29155C11.7319 8.6279 11.7699 8.95546 11.8431 9.2696C8.27633 9.0906 5.114 7.38203 2.99734 4.78551C2.6279 5.41935 2.41626 6.15656 2.41626 6.94309C2.41626 8.43204 3.17389 9.74563 4.32548 10.5153C3.62204 10.4929 2.96021 10.2999 2.38164 9.97846C2.38123 9.99639 2.38123 10.0143 2.38123 10.0324C2.38123 12.1118 3.86057 13.8463 5.82383 14.2406C5.46373 14.3387 5.08458 14.3912 4.69318 14.3912C4.41665 14.3912 4.1478 14.3642 3.88571 14.3142C4.43186 16.0191 6.01677 17.26 7.89478 17.2945C6.426 18.4457 4.57552 19.1318 2.56478 19.1318C2.21837 19.1318 1.87676 19.1114 1.54102 19.0717C3.44028 20.2894 5.69615 21 8.11974 21C16.0136 21 20.3304 14.4605 20.3304 8.78918C20.3304 8.60314 20.3262 8.41805 20.3179 8.23395C21.1565 7.62886 21.8841 6.87302 22.4594 6.01238Z",
    fill: "#22034F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.757fe837bebeea646b2a1e1051a9ecd0.svg";
export { ForwardRef as ReactComponent };